import { observer } from 'owa-mobx-react';
import { setNextStyleIsEnabled } from 'owa-acui';
import { useAppTheme } from './useAppTheme';

export const RibbonThemeV9: React.FC<{
    children: React.ReactNode;
}> = observer(({ children }) => {
    setNextStyleIsEnabled(true);
    useAppTheme();

    return children;
}, 'RibbonThemeV9');
